// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"205":"c90ed7f2","208":"80a0a543","236":"bf2f01f9","353":"4fdbf162","512":"c07ea300","549":"12a458dd","813":"d8c2d5fb"}[chunkId] + ".chunk.js";
};